export default __webpack_public_path__ + "images/0xeceeefcee421d8062ef8d6b4d814efe4dc898265.png";